import { Router } from '@angular/router';
import { SettingsService } from '../shared/services';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { AppPageComponent } from '../../shared/ui/app-page/app-page.component';
import { TopLevelComponent, User } from '../../shared/models';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { Subscription } from 'rxjs';
import { MobileUserSettings, PersonalInfo } from '../shared/models';
import { ConfigService } from '../../shared/services';
import { FormGroup } from '@angular/forms';


@Component({
    template: require('./personal-info.component.pug'),
    styles: [ require('./personal-info.component.scss')],
})
export class PersonalInfoComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;

    subs: Subscription[] = [];
    settings: MobileUserSettings;
    animation = 'fadeIn';

    error: string = '';
    loading = true;

    private _user: User;
     _baseUrl: string;

    rnd: number;

    editMode = false;

    fg: FormGroup = new FormGroup({});

    constructor(store: Store,
                storeHelper: StoreHelper,
                userService: UserService,
                private _config: ConfigService,
                private _settingsService: SettingsService,
                private _router: Router) {
        super(store, storeHelper, userService);
        this.headerTitle = 'Settings';
        this.headerActions = [{ id: 'none', icon: 'none' }];
        this.userService.user$.subscribe(user => this._user = user);
        this._baseUrl = this._config.getContext('management').url;
    }

    ngOnInit() {
        this.getUserSettings();
        this.rnd = Math.floor(Math.random() * 11);
    }

    getUserSettings() {
        this.subs.push(this._settingsService.getUserSettings()
            .subscribe(
                s => this.settings = s,
                err => this.error = err,
                () => this.requestSuccess()
        ));
    }

    ngOnDestroy() {
        this.subs.forEach(u => u.unsubscribe());
    }

    requestSuccess() {
        this.loading = false;
        this.appPage.deactivatePreloader();
        this.animation = 'fadeIn';
    }

    onSaveInfo(save: boolean) {
        if (!save) {
            this.editMode = false;
            return;
        }

        this.animation = 'fadeOut';

        let personalInfo = new PersonalInfo({
           phoneNumber: this.fg.value.phoneNumber,
           email: this.fg.value.email,
           providerId: Number(this.fg.value.providerId) || null
        });

       this.appPage.activatePreloader();

       let response;

       this.subs.push(this._settingsService.setUserSettings(personalInfo)
            .subscribe(
                r => response = r,
                err => this.error = err,
                () => {
                    this.getUserSettings();
                    this.editMode = false;
                    return;
                }
        ));
    }

    onEditInfoAction(event: boolean) {
        this.editMode = true;
    }

    get username(): string {
        return this._user ? this._user.name : 'User';
    }

    get imageUrl() {
       return `${this._baseUrl}${this.settings.imageUrl}?rnd=${this.rnd}`;
    }

    changePassword() {
        this.navigate('/settings/password');
    }

    navigate(route: string) {
        this._router.navigate([route]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/personal-info/personal-info.component.ts